import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	processCardInfo: {
		isLoading: false,
		hasCompleted: false,
		error: undefined,
		data: {}
	}
};

export const processCardInfoSlice = createSlice({
	name: 'processCardInfo',
	initialState,
	reducers: {
		processCardInfo: (state) => {
			state.processCardInfo.isLoading = true;
		},
		processCardInfoCompleted: (state, action) => {
			state.processCardInfo.isLoading = false;
			state.processCardInfo.hasCompleted = true;
			state.processCardInfo.data = action.payload;
		},
		processCardInfoFailed: (state, action) => {
			state.processCardInfo.isLoading = false;
			state.processCardInfo.error = action.payload;
		},
		processCardInfoReset: (state) => {
			state.processCardInfo = initialState.processCardInfo;
		}
	}
});

export const {
	processCardInfo,
	processCardInfoCompleted,
	processCardInfoFailed,
	processCardInfoReset
} = processCardInfoSlice.actions;

export default processCardInfoSlice.reducer;
